if (!customElements.get("td-video-modal")) {
  class tdVideoModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeModal();
    }

    initializeModal() {
      this.activeModalVideos = null;
      this.activeModal = null;
      this.volumeButton = this.querySelector('[volume-trigger]');
      this.modalOverlay = document.querySelector('.td-video-modal__overlay');
      this.slider = this.querySelector('swiper-slider');
      this.modalButtons = document.querySelectorAll('[modal-trigger]');
      
      this.modalButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const selectedSlide = this.slider.querySelector(`#${button.getAttribute("target")}`);
          let targetIndex = null;
          if (selectedSlide) {
            targetIndex = Array.from(this.slider.slides).findIndex(slide => slide.id === selectedSlide.id);
          }
          this.activeModal = document.getElementById(button.getAttribute('modal-id'));
          this.activeModal && this.activeModal.hasAttribute('open') 
              ? this.close(this.activeModal) 
              : this.open(this.activeModal, targetIndex);
          this.scrollToTargetSlide(targetIndex);
          let modal = this.activeModal;
          setTimeout(function() {
            modal.querySelector('button').focus();
          }, 300);
        });
      });

      // Add a click handler to the document to close the modal when clicking outside
      document.addEventListener('click', (event) => {
        // Only close if we have an active modal and the click was outside it
        if (this.activeModal && !this.activeModal.contains(event.target)) {
          // Check if the click was on the volume button or its children
          const isVolumeButtonClick = this.volumeButton && 
            (this.volumeButton === event.target || this.volumeButton.contains(event.target));
          
          // Check if the click was on a modal trigger
          const isModalTriggerClick = event.target.closest('[modal-trigger]');
          
          // Only close if the click wasn't on the volume button or a modal trigger
          if (!isVolumeButtonClick && !isModalTriggerClick) {
            this.close(this.activeModal);
          }
        }
      });

      if (this.volumeButton) {
        this.volumeButton.addEventListener('click', (event) => {
          // Stop the click event from propagating to the document
          event.stopPropagation();
          this.toggleVolume();
        });
      } else {
        console.warn("Volume button is not found or not initialized.");
      }
    }

    open(modal, targetIndex) {
      this.activeModalVideos = modal.querySelectorAll('video');
      document.body.classList.add('scroll-hidden--mobile');
      this.modalOverlay.classList.add('td-video-modal__overlay--active');
      
      if (modal) {
        modal.setAttribute('open', '');
      }

      if(targetIndex == 0) this.playVideo(targetIndex);
      this.setVideosVolume(.25);
    }

    scrollToTargetSlide(index) {
      this.slider.goToSlide(index);
    }

    async playVideo(videoIndex) {
      if(this.activeModalVideos[videoIndex]) {
        try {
          // Store the play promise
          const playPromise = this.activeModalVideos[videoIndex].play();
          
          // If the browser supports promises, wait for it to complete
          if (playPromise !== undefined) {
            await playPromise;
            // Now it's safe to pause if needed
          }
        } catch (error) {
          console.warn('Error playing video:', error);
        }
      }
    }

    toggleVolume() {
      if (this.volumeButton) {
        this.volumeButton.setAttribute('muted', `${this.volumeButton.getAttribute('muted') == 'false' ? true : false}`); 
          
        if(this.volumeButton.getAttribute('muted') == 'true') {
          this.volumeButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.508.867C12.313.79 12.156.79 12 .79c-.313 0-.625.078-.86.313L5.868 5.75H2.625C1.57 5.75.75 6.61.75 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.196.546.313.859.313.156 0 .313-.04.508-.117.43-.196.703-.664.703-1.133V2c0-.469-.274-.938-.703-1.133Zm-1.133 14.766-4.766-4.258H2.625v-3.71h3.984l4.766-4.259v12.227ZM20.789 9.5l1.836-1.836c.39-.39.39-.976 0-1.328-.352-.39-.938-.39-1.328 0L19.5 8.21l-1.875-1.875c-.39-.352-.977-.352-1.328 0-.39.39-.39.976 0 1.328L18.133 9.5l-1.836 1.836c-.39.39-.39.976 0 1.328.351.39.937.39 1.328 0l1.875-1.836 1.836 1.836c.352.39.937.39 1.289 0 .39-.351.39-.937 0-1.328L20.789 9.5Z" fill="#fff"></path></svg>';
          this.setVideosVolume(0);
        } else {
          this.volumeButton.innerHTML = '<svg width="20" height="17" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.758.867A1.349 1.349 0 0 0 11.25.75c-.313 0-.625.117-.86.352L5.118 5.75H1.875C.82 5.75 0 6.61 0 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.313.546.391.859.391.156 0 .313 0 .508-.078.43-.235.742-.664.742-1.172V2c0-.469-.313-.938-.742-1.133Zm-1.133 14.766-4.766-4.258H1.875v-3.71h3.984l4.766-4.259v12.227Zm5.469-9.024a1.053 1.053 0 0 0-.586-.195.962.962 0 0 0-.742.352.942.942 0 0 0 .156 1.328c.43.351.703.86.703 1.406a1.85 1.85 0 0 1-.703 1.445.942.942 0 0 0-.156 1.328.962.962 0 0 0 .742.352c.195 0 .43-.078.586-.195.898-.742 1.406-1.797 1.406-2.93 0-1.094-.508-2.148-1.406-2.89Zm2.383-2.89c-.196-.117-.391-.196-.625-.196-.274 0-.508.118-.704.352-.351.39-.273.977.118 1.328 1.328 1.055 2.109 2.656 2.109 4.297 0 1.68-.781 3.281-2.11 4.336-.39.351-.468.937-.117 1.328.196.234.43.352.704.352.234 0 .43-.079.625-.196 1.757-1.445 2.773-3.554 2.773-5.82 0-2.227-1.016-4.336-2.773-5.781Z" fill="#fff"></path></svg>';
          this.setVideosVolume(.25);
        }
      }
    }

    async pauseAllVideos() {
      if (Array.from(this.activeModalVideos).length) {
        for (const video of this.activeModalVideos) {
          if (video && !video.paused) {
            try {
              // Check if the video is actually playing
              if (!video.paused && !video.ended && video.currentTime > 0) {
                video.pause();
              }
            } catch (error) {
              console.warn('Error pausing video:', error);
            }
          }
        }
      }
    }

    setVideosVolume(newVolume) {
      if (this.activeModalVideos) {
        this.activeModalVideos.forEach(video => {
          if (newVolume > 0) {
            video.muted = false;
            video.volume = newVolume;
          } else {
            video.muted = true;
            video.volume = newVolume;
          }
        });
      }
    }

    close(modal) {
      document.body.classList.remove('scroll-hidden--mobile');
      this.modalOverlay.classList.remove('td-video-modal__overlay--active');
      if (modal) {
        modal.removeAttribute('open');
      }
      this.pauseAllVideos();
      this.setVideosVolume(0);
    }
  }

  customElements.define('td-video-modal', tdVideoModal);
}
